import { useNavigate, useParams } from 'react-router-dom';

import './newbtn.css';


/* ── ICONS ── */
const IcoBolt  = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M13 2L4.09 12.96A1 1 0 0 0 5 14.5h6.5L10 22l9.91-10.96A1 1 0 0 0 19 9.5H12.5L13 2z"/>
  </svg>
);
const IcoArrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);


export default function NewVersionButton({ route }) {
  const navigate = useNavigate();
  const { business_code } = useParams();
 
  const handleClick = () => {
    if (!route) return;
    /* Construye /{route}/{business_code} igual que el resto del proyecto */
    navigate(`/${route}/${business_code}`);
  };
 
  return (
    <div className="nvb-wrap">

      {/* Botón principal */}
      <button className="nvb-btn" onClick={handleClick} type="button">
 
        {/* Efecto shimmer */}
        <span className="nvb-shimmer" aria-hidden="true" />
 
        {/* Ícono rayo */}
        <span className="nvb-bolt" aria-hidden="true">
          <IcoBolt />
        </span>
 
        {/* Texto */}
        <span className="nvb-label">
          <span className="nvb-label-top">Disponible ahora</span>
          <span className="nvb-label-main">Nueva versión</span>
        </span>
 
        {/* Flecha */}
        <span className="nvb-arrow" aria-hidden="true">
          <IcoArrow />
        </span>
 
      </button>
    </div>
  );
}